var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"node-hover-onboarding-controls-palette-buttons"},_vm._l((_vm.groupedGlobalColors),function(colorGroup,index){return _c('NodeOnboardingPaletteButton',{key:index,attrs:{"colorGroup":colorGroup,"elementId":_vm.element.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }